import { memo, useContext, useEffect, useState } from "react";

import appStyles from "../../../App.module.css";
import { PortuguesePurchasePathContext } from "../../PortuguesePurchasePath";
import PortugueseQuoteApi from "../../api/PortugueseQuoteApi";
import { IPortuguesePurchasePathContext } from "../../config/interface";

const PPHeader = () => {
  const { currentStep, quoteData } = useContext(PortuguesePurchasePathContext) as IPortuguesePurchasePathContext;

  const [partnerLogo, setPartnerLogo] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  // getting Partner logo on the basis of partner id
  useEffect(() => {
    const getPartnerLogo = async () => {
      try {
        if (!quoteData?.affiliate_id || quoteData.affiliate_id === "1") {
          return;
        }
        const partnerResponse = await PortugueseQuoteApi.getPartnerLogo(quoteData.affiliate_id);
        if (partnerResponse.errors) {
          setPartnerLogo(() => null);
          return;
        }

        setPartnerLogo(() => partnerResponse?.data?.logo_path);
      } catch (error) {
        setPartnerLogo(() => null);
      } finally {
        await new Promise((r) => setTimeout(r, 600));
        setLoading(() => false);
      }
    };

    getPartnerLogo();
  }, [quoteData.affiliate_id]);

  return (
    <>
      {!loading ? (
        <div
          className={` ${appStyles.MY20} ${
            partnerLogo
              ? [
                  `${appStyles.footerLogosWrap} ${
                    currentStep === 1 || currentStep === 2 ? appStyles.btW900 : appStyles.btW600
                  }`,
                ]
              : appStyles.footerLogosWrapper
          } `}
        >
          {partnerLogo ? (
            <>
              <div className={`${appStyles.partnerLogoWrapper} ${appStyles.partnerLogoImgWrap}`}>
                <img src={partnerLogo} alt="Partner Logo" />
              </div>

              <div className={`${appStyles.poweredbyLogoWrapper} ${appStyles.poweredByBorderLeft}`} />
            </>
          ) : (
            <div className={appStyles.BattleFaceBGLogo}></div>
          )}
        </div>
      ) : (
        <div className={`${appStyles.ppBattleFaceBGLogo} ${appStyles.MY20}`}></div>
      )}
    </>
  );
};

export default memo(PPHeader);
